import { useEngineInstance } from '@surveycake/react-logic-engine';
import { PageService } from 'app/core/page';
import { ExceptionService } from 'app/core/status';
import { useSurveyConfig } from 'app/core/survey-config';
import {
  SetIsCompleted,
  SetNotAllowed,
  ActiveDirectoryLoginDeps,
  ActiveDirectoryAutoLogin,
  AlreadySubmit
} from 'app/modules/third-party-login';
import { createToken } from 'app/core/http';
import React, { useEffect } from 'react';
import {
  activeDirectoryAutoLoginEnable,
  adLoginGoogleRecaptchaKey,
  enableAdLoginGoogleRecaptcha,
} from 'config/system';
import includeRecaptchaScript from 'app/modules/reCAPTCHAV3';
import Cookies from 'js-cookie';
import { parse } from 'qs';
import { parseJwt } from '@surveycake/utils';

function ActiveDirectory({
  setIsCompleted,
  setNotAllowed
}: {
  setIsCompleted: SetIsCompleted;
  setNotAllowed: SetNotAllowed;
}) {
  const surveyConfig = useSurveyConfig();
  const engine = useEngineInstance();
  const setPage = PageService.useSetPage();
  const setException = ExceptionService.useSetException();
  const checkActiveDirectoryLoginDeps: ActiveDirectoryLoginDeps = [
    surveyConfig,
    engine,
    setPage,
    setException,
    setIsCompleted,
    setNotAllowed
  ];

  if (enableAdLoginGoogleRecaptcha) {
    includeRecaptchaScript(document, adLoginGoogleRecaptchaKey);
  }

  const CheckLogin = async () => {
    // 這邊讀 mbr_id or ad_id，如果有就是半登入狀態，可以透過這個 key 去確認 user 是否已填過問卷
    const { jwt } = parse(window.location.search, {
      ignoreQueryPrefix: true
    });

    if (jwt) {
      const { mbr_id: jwtMbrId, email, name, exp } = parseJwt(jwt);
      // 以 BS 回來的為主，優先更新 mbr_id
      Cookies.set('mbr_id', jwtMbrId);
      // 判斷是否過期
      if (Date.now() > exp * 1000) {
        Cookies.remove('mbr_id');
      } else {
        // 沒過期才換 token
        const { data, status } = await createToken(jwtMbrId, email, name);
        if (status && data) {
          const { access_token, refresh_token } = data;
          Cookies.set('userToken', access_token);
          Cookies.set('refreshToken', refresh_token);
        }
      }

      // 清除 query
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete('jwt');
      window.history.replaceState(window.history.state, '', currentUrl.href);

      // 不再處理 createToken 失敗的情境，也不導去 BS 登入頁
      // 下方繼續取 mbr_id 做後續判斷
    }

    // 如果上面登入完成這裡就會拿到最新的 mbr_id 進行後續的檢查
    const mbr_id = Cookies.get('mbr_id') || Cookies.get('ad_id');
    if (mbr_id) {
      const isAlreadySubmit = await AlreadySubmit(
        surveyConfig.surveyHash,
        mbr_id
      );

      if (isAlreadySubmit === 'ALREADY_DONE') {
        setIsCompleted(true);
      } else if (isAlreadySubmit === 'NOT_ALLOWED') {
        setNotAllowed(true);
      } else {
        engine.setThirdPartyLogin(mbr_id);
        surveyConfig.handleStageFinished(setPage, setException);
      }
    // 當沒有 mbr_id 也沒有 jwt 那就要進行 auto login
    } else {
      if (activeDirectoryAutoLoginEnable) {
        ActiveDirectoryAutoLogin(checkActiveDirectoryLoginDeps);
      }
    }
  };

  useEffect(() => {
    CheckLogin();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div/>
  );
}

export default ActiveDirectory;
